import logger from 'packages/logger';
import memberInfo from '../data/member-info';
import antiForgeryToken from '../data/anti-forgery-token';
import BodyContainer from '../ui/layout/body-container';
import SiteHeaderProfile from '../ui/layout/site-header-profile';
import SideMenuUI from '../ui/layout/side-menu-ui';
import SideMenuNotificationsUI from '../ui/layout/side-menu-notifications-ui';
import SiteHeaderNotificationsUI from '../ui/layout/site-header-notifications-ui';
import Navigation from '../ui/layout/navigation';
import ToggleElementsUI from '../ui/toggle-elements';
import NavigationData from '../data/navigation';
import NavigationFilterData from '../data/navigation-filter';
import MessageBoxUI from '../ui/message-box-ui';
import SiteSearch from '../ui/layout/site-search';
import NavCategoriesUI from '../ui/layout/nav-categories-ui';
import CategoriesSectionUI from '../ui/categories-section-ui';
import GoogleTagManager from '../ui/layout/google-tagmanager';
import disableZoomIfAndroidChrome from '../../utils/disable-zoom';
import WindowResize from '../../utils/window-resize';
import TempData from '../data/temp-data';
import Loading from '../ui/loading';
import ModalUI from '../ui/modal-ui';
import ModalTooltipUI from '../ui/modal-tooltip-ui';
import NavigationModal from '../data/navigation-modal';
import Login from '../ui/layout/login';
import FeatureFeedbackLink from '../ui/feature-feedback/feature-feedback-link';
import SavedSearchMonitorTogglerUI from '../ui/saved-search-monitor-toggler-ui';
import WindowLoad from '../../utils/window-load';
import WindowScroll from '../../utils/window-scroll';
import PreventDefault from '../../utils/prevent-default';
import HybridAppEvents from '../../utils/hybrid-app-events';
import isHybridAppWithMinBuild from '../../utils/is-hybrid-app-with-min-build';
import Nuggad from '../ui/layout/ads/nuggad';
import SignupReferralPathCookieCreator from '../ui/layout/signup-referral-path-cookie-creator';
import TriotFlightBridge from '../../utils/triot-flight-bridge';
import Blueshift from '../../utils/blueshift';
import reactAdsLoader from '../../components/ads/boot-react-ads';
import * as LoginSignupEvents from '../ui/layout/login-signup-events';
import store from 'store';
import { loadModule, handleError } from 'utils/code-split';
import CookieNotification from '../../components/alerts/cookies/';
import '../../components/customer-feedback/mopinion-button-renderer';

const enableBlueshift = (initData, Blueshift) => {
    Blueshift.attachTo(document, {
        initData: initData
    });
};

const cookieNotification = () => {
    const domNode = document.querySelector(
        '[data-component-cookie-notification]'
    );
    //only load this if it ain't already dismissed
    if (!store.get('cookieNotification') && domNode) {
        CookieNotification(domNode);
    }
};

const attachFlightComponents = initData => {
    if (initData.enablePushState) {
        Navigation.attachTo(document);
    }

    SiteSearch.attachTo('[data-search-field]', {
        initData: initData
    });

    NavigationFilterData.attachTo(document);
    // this service is needed even when pushstate is disabled
    NavigationData.attachTo(document, {
        enablePushState: initData.enablePushState,
        version: initData.version
    });
    GoogleTagManager.attachTo(document);

    PreventDefault.attachTo(document.body);
    ModalUI.attachTo(document.body);
    ModalTooltipUI.attachTo(document.body);
    BodyContainer.attachTo(document.body, {
        initData: initData
    });
    SiteHeaderNotificationsUI.attachTo('[data-site-header-notifications]');
    SiteHeaderProfile.attachTo('[data-site-header-profile]');
    SideMenuUI.attachTo('[data-side-menu]');
    SideMenuNotificationsUI.attachTo('[data-side-menu]');
    MessageBoxUI.attachTo('.message-box-wrapper');
    NavCategoriesUI.attachTo('.nav-categories');
    ToggleElementsUI.attachTo('[data-search-filter-box]');
    CategoriesSectionUI.attachTo('.view-categories-category');
    disableZoomIfAndroidChrome();
    WindowResize.attachTo(document);

    TempData.attachTo('#temp-data');
    Loading.attachTo(document);
    NavigationModal.attachTo(document);
    Login.attachTo(document);
    FeatureFeedbackLink.attachTo(document, {
        initData: initData
    });
    SavedSearchMonitorTogglerUI.attachTo(document.body);
    WindowLoad.attachTo(document);
    WindowScroll.attachTo(document);

    if (isHybridAppWithMinBuild(1)) {
        HybridAppEvents.attachTo(document);
    }

    SignupReferralPathCookieCreator.attachTo('[data-reg-user-link]');
    TriotFlightBridge.attachTo(document);

    // do not enable Nuggad for /selling
    if (window.location.pathname.indexOf('/selling') < 0) {
        Nuggad.attachTo(document);
    }

    LoginSignupEvents.NavigateToSignupLinkComponent.attachTo(
        '[data-reg-user-link]'
    );
    LoginSignupEvents.TrackLoginSuccessComponent.attachTo(
        '[data-track-login-success]'
    );
    LoginSignupEvents.TrackConnectSuccessComponent.attachTo(
        '[data-track-connect-success]'
    );
    LoginSignupEvents.TrackLoginFailureComponent.attachTo(
        '[data-track-login-failure]'
    );
    LoginSignupEvents.TrackConnectFailureComponent.attachTo(
        '[data-track-connect-failure]'
    );
};

export default initData => {
    const { featureSwitches, pageName } = initData;

    memberInfo.set(initData);
    antiForgeryToken.set(initData);
    cookieNotification();
    attachFlightComponents(initData);

    /* jshint ignore:end */
    if ('gptData' in initData) {
        try {
            reactAdsLoader(initData);
        } catch (error) {
            logger(error);
        }
    }

    if (!featureSwitches) {
        return;
    }
    if (featureSwitches['blueshift-tracking']) {
        enableBlueshift(initData, Blueshift);
    }
    if (
        featureSwitches.humany &&
        (pageName === 'MyTradera' || pageName === 'MyTradera_Invoices')
    ) {
        import(/* webpackChunkName: "humany-bot" */ '../../components/humany/humany-bot')
            .then(module => loadModule(module, initData))
            .catch(handleError);
    }

    if (featureSwitches['quick-view']) {
        import(/* webpackChunkName: "quick-view" */ '../../components/quick-view/')
            .then(module => loadModule(module))
            .catch(handleError);
    }
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/boot/boot-layout.js